import { render, staticRenderFns } from "./ProductExtraOptionRequestedByEntitySelector.vue?vue&type=template&id=000a6f51&"
import script from "./ProductExtraOptionRequestedByEntitySelector.vue?vue&type=script&lang=js&"
export * from "./ProductExtraOptionRequestedByEntitySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports